import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Link } from "react-router-dom";
const styles = theme => ({
    root: {
      flexGrow: 1,
      maxWidth: 1330,
      margin: 'auto',
    }
  });
class Hero extends Component {
    routeChange = () => {
        window.location.href = "https://rkbaaz-skyy.firebaseapp.com";
    }
    render() {
        const { classes } = this.props;
        return (
            <section className={classes.root}>
                <div className="hero-section" item xs={12} container>
                    <div className="hero-section-text">
                        <h1>Start savings for your</h1>
                        <div className="kids_education">
                            <img src={require('../../assets/images/kids_education.png')} />
                        </div>
                        <p>Turn birthday and parties into cash for your children's education.</p>
                        <div className="event_host">
                            <Link to='/login'>
                                <button ><img src={require('../../assets/images/hero-horn.png')} />HOST AN EVENT</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
Hero.propTypes = {
    classes: PropTypes.object.isRequired,
  };
export default withStyles(styles)(Hero);


// WEBPACK FOOTER //
// ./src/components/Landing/Hero.js